import React, { useEffect } from "react";
import SubTitle from "../../components/SubTitle";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { useUpdateMutation } from "../../hooks/useQueryHooks";
import { ResponseItem, ResponseList } from "../../models/clientModels/interfaces/Response";
import { useNavigate, useParams } from "react-router-dom";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import * as postAip from "../../api/boardApi/postAip";

import { useQuery, useQueryClient } from "react-query";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackBarState, snackBarToggleState } from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import { FormSection } from "../../styledComponents/StyledCreateForm";
import MWProgress from "../../components/MWProgress";
import { tokenSelector } from "../../Recoil/Atom/authState";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { KPBoard, initializeBoard } from "../../models/serverModels/board/KPBoard";
import PostForm from "./PostForm";
import { KPPost, initializePost } from "../../models/serverModels/board/KPPost";

const UpdatePost = () => {
  const { id, name } = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const { data: postItem, isLoading: isGetLoading } = useQuery(
    ["PostItem", { token: tokenState, id: parseInt(id!) }],
    () => postAip.getItem({ token: tokenState, id: parseInt(id!) })
  );

  const { mutate: updateMutate, isLoading: isUpdateLoading } = useUpdateMutation<
    ResponseItem<KPPost>,
    Params.Update<KPPost>
  >({
    api: postAip.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(`/Post/${postItem?.item?.boardUID}`);
        queryClient.invalidateQueries("getBoardWithPostList");
      },
    },
  });

  const methods = useForm<KPPost>({
    defaultValues: postItem?.item || initializePost(postItem?.item?.boardUID),
  });

  const { reset } = methods;

  useEffect(() => {
    reset(postItem?.item);
  }, [postItem?.item, reset]);

  const onSubmit: SubmitHandler<KPPost> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: { ...initializePost(postItem?.item?.boardUID), ...data },
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle={`${name} 수정`} />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <PostForm />
            <ConfirmButtonGroup
              link={`/Post/${postItem?.item?.boardUID}`}
              cancelText="취소"
              confirmText="수정"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdatePost;
